import { MglMarker, MglNavigationControl } from '@advisr/v-mapbox';
import MapService from '../../../../../services/mapService';
import cloneDeep from 'lodash/cloneDeep';
export default {
  name: 'CoreDtwinMapOverlayWizardGeoAnchorPicker',
  components: {
    MglMarker,
    MglNavigationControl
  },
  props: {
    overlayInfo: {
      type: Object,
      required: false,
      default: null
    },
    addressObjectParam: {
      type: Object,
      required: true
    }
  },
  data: function () {
    return {
      addressObject: {
        coordinates: []
      },
      anchor1: null,
      anchor2: null
    };
  },
  watch: {
    overlayInfo() {
      this.drawOverlay();
    },
    addressObjectParam() {
      const obj = cloneDeep(this.addressObjectParam);
      if (!obj.coordinates) {
        obj.coordinates = [];
      }
      this.addressObject = obj;
    },
    'addressObject.polygon'() {
      this.drawOverlay();
    }
  },
  mounted() {
    const obj = cloneDeep(this.addressObjectParam);
    if (!obj.coordinates) {
      obj.coordinates = [];
    }
    this.addressObject = obj;
    if (this.addressObject.polygon) {
      this.drawOverlay();
    }
  },
  methods: {
    drawOverlay() {
      if (!this.map) {
        return;
      }
      // the geo-polygon (if there is one) should always be at the very top
      // so for each added layer, set its id here to put the polygon on top of it
      let currentTopLayer = 'groundLayer';
      if (!this.map.getSource('empty')) {
        // since there is no direct z-index property, create dummy layers under which stuff is positioned
        // drawOverlay should be called before any draw-controls for polygons are added,
        // as to make sure this is really at the bottom
        this.map.addSource('empty', {
          type: 'geojson',
          data: {
            type: 'FeatureCollection',
            features: []
          }
        });
        this.map.addLayer({
          id: currentTopLayer,
          type: 'symbol',
          source: 'empty'
        });
      }
      const overlayId = 'overlay';
      if (this.map.getLayer(overlayId)) {
        this.map.removeLayer(overlayId);
      }
      if (this.map.getSource(overlayId)) {
        this.map.removeSource(overlayId);
      }
      if (this.overlayInfo) {
        this.map.addSource(overlayId, {
          type: 'image',
          url: this.overlayInfo.image,
          coordinates: this.overlayInfo.coordinates
        });
        this.map.addLayer({
          id: overlayId,
          source: overlayId,
          type: 'raster',
          paint: {
            'raster-opacity': 0.65
          }
        }, currentTopLayer);
        currentTopLayer = overlayId;
      }
      if (this.addressObject.polygon.length) {
        const overlayWizardId = 'overlayWizard';
        if (this.map.getLayer(overlayWizardId)) {
          this.map.removeLayer(overlayWizardId);
        }
        if (this.map.getSource(overlayWizardId)) {
          this.map.removeSource(overlayWizardId);
        }
        let polygonGeoJson = {
          type: 'geojson',
          data: {
            type: 'FeatureCollection',
            crs: {
              type: 'name',
              properties: {
                name: 'urn:ogc:def:crs:OGC:1.3:CRS84'
              }
            },
            features: [{
              type: 'Feature',
              properties: {},
              geometry: {
                type: 'Polygon',
                coordinates: this.addressObject.polygon
              }
            }]
          }
        };
        this.map.addSource(overlayWizardId, polygonGeoJson);
        let color = MapService.markerColor('warning');
        this.map.addLayer({
          id: overlayWizardId,
          type: 'fill-extrusion',
          source: overlayWizardId,
          paint: {
            'fill-extrusion-color': color,
            'fill-extrusion-opacity': 0.5,
            'fill-extrusion-height': 2,
            'fill-extrusion-base': 0
          }
        }, currentTopLayer);
      }
    },
    onMapLoaded(e) {
      this.map = e.map;
      this.drawOverlay();
    },
    onMapClicked(e) {
      if (!this.anchor1) {
        this.anchor1 = [e.mapboxEvent.lngLat.lng, e.mapboxEvent.lngLat.lat];
        this.$emit('update-anchor1-coordinate', {
          lon: this.anchor1[0],
          lat: this.anchor1[1]
        });
      } else if (!this.anchor2) {
        this.anchor2 = [e.mapboxEvent.lngLat.lng, e.mapboxEvent.lngLat.lat];
        this.$emit('update-anchor2-coordinate', {
          lon: this.anchor2[0],
          lat: this.anchor2[1]
        });
      }
    },
    addressSelected(addressData) {
      // preserve the polygon data, as this is not returned by the address-picker
      this.addressObject = {
        ...addressData,
        polygon: this.addressObject.polygon
      };
      if (this.map !== undefined) {
        this.map.flyTo({
          center: addressData.coordinates,
          pitch: 0,
          bearing: 0,
          zoom: 19.2,
          duration: 1500,
          animate: true
        });
      }
    },
    onMarker1Dragged(e) {
      const latLng = e.mapboxEvent.target['_lngLat'];
      this.$emit('update-anchor1-coordinate', {
        ...latLng,
        lon: latLng.lng
      });
    },
    onMarker2Dragged(e) {
      const latLng = e.mapboxEvent.target['_lngLat'];
      this.$emit('update-anchor2-coordinate', {
        ...latLng,
        lon: latLng.lng
      });
    }
  }
};